import { Injectable } from '@angular/core';
import { AbstractFeatureAclService } from '@y42/feature/acl';
import { Y42FeatureType } from '@y42/json-schema';
import { SqlModelingQuery } from '../../state';

@Injectable({ providedIn: 'root' })
export class SqlModelingAclService extends AbstractFeatureAclService<Y42FeatureType.SqlModel> {
  constructor(query: SqlModelingQuery) {
    super({
      featureType: Y42FeatureType.SqlModel,
      query,
    });
  }
}
